import { initializeApp } from "firebase/app";
import { getAuth, setPersistence, browserLocalPersistence } from "firebase/auth";

// Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyBXGOEtde0X9UPY4yJtBo-5B3fm94swU1I",
    authDomain: "tribemails-platform.firebaseapp.com",
    projectId: "tribemails-platform",
    storageBucket: "tribemails-platform.firebasestorage.app",
    messagingSenderId: "742801182805",
    appId: "1:742801182805:web:4238c726c4da711b2804dc",
    measurementId: "G-4XT3MQCH4F"
};


// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
const auth = getAuth(app);

// Set persistence immediately
setPersistence(auth, browserLocalPersistence)
  .then(() => {
    console.log("Firebase: Persistence set to LOCAL");
  })
  .catch((error) => {
    console.error("Firebase: Error setting persistence:", error);
  });

console.log("Firebase Auth initialized:", auth);


export { app, auth, firebaseConfig };
